import React, { useEffect } from 'react';
import { Store } from 'redux';
import { Provider } from 'react-redux';
import ConnectedFlagsProvider from '@wix/da-react-context/pkg/flags/ConnectedFlagsProvider';
import Document, { type DocumentProps } from '../Document';
import SessionProvider from '../SessionProvider/SessionProvider';

export interface Props extends Pick<DocumentProps, 'themeSelector' | 'themeSkinSelector'> {
  store: Store;
  themeSelector?: any;
  themeSkinSelector?: any;
  /** DaApp */
  children: React.ReactNode;
}

const AppDocumentWrapper: React.FC<Props> = ({
  store,
  children,
  themeSelector,
  themeSkinSelector,
}) => {
  const isDebug = store.getState()?.flags?.hasOwnProperty('redux_selector_debug');
  const reduxStabilityCheck = isDebug ? 'always' : 'never';

  useEffect(() => {
    performance.mark('RCacheAppStartup');
  }, []);

  return (
    <Provider store={store} stabilityCheck={reduxStabilityCheck}>
      <SessionProvider>
        <ConnectedFlagsProvider>
          <Document themeSelector={themeSelector} themeSkinSelector={themeSkinSelector}>
            {children}
          </Document>
        </ConnectedFlagsProvider>
      </SessionProvider>
    </Provider>
  );
};
AppDocumentWrapper.displayName = 'AppDocumentWrapper';

export default AppDocumentWrapper;
